/**
 * Title/path only for catalogue routes — no page components.
 * Import this from modules (e.g. header) that must not pull the full catalogue route graph.
 */
export const cataloguePageMetadata = {
  MY_APPS_AND_SERVICES: {
    title: "My Apps & Services",
    path: "/catalogue/my-apps-and-services",
  },
} as const;
